import { SecurePath as SecurePathT } from "@max/common/firestore";
import { api } from "api";
import { Dispatch, SetStateAction } from "react";
import { SecurePath } from "refs";

/**
 *
 * @param artistGroupId
 * @param key - "email" | "phone"
 * @param fanId - fan email hash
 * @param setLoading
 * @param securePath - optional secure path. defaults to the artist group's fan profile for the fanId
 * @returns - the unencrypted data
 */
export const getPiiData = async (
  artistGroupId: string,
  key: PiiKey,
  fanId: string,
  setLoading: Dispatch<SetStateAction<boolean>>,
  securePath?: SecurePathT,
): Promise<string> => {
  setLoading(true);
  const response = await api.call("conversation.participant", {
    securePath:
      securePath ??
      SecurePath("artist_groups/{groupId}/fans/{fanId}", {
        groupId: artistGroupId,
        fanId,
      }),
  });

  setLoading(false);
  return response.data?.data?.[key] || "";
};

export type PiiKey = "phone" | "email";
